/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import '../../../styles/NewClaimPage.scss';
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  isLoaded,
} from 'react-redux-firebase';
import { INewClaimReducer } from '../../../reducers/reducers/typings';
import { NewClaimsComponentProps } from './typings';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ensureGlassPositionOptions, ensureOriginMemberField } from '../../../helpers/utils';
import { resetClaim } from '../../../actions/new-claim';
import Helmet from 'react-helmet';
import LoadingPage from '../../loading/LoadingPage';
import NewClaimForm from './ClaimForm/NewClaimForm';
import React, { Component } from 'react';
import _ from 'lodash';

class NewClaimPage extends Component<
  RouteComponentProps & FirebaseReducer.Reducer & NewClaimsComponentProps
> {
  componentDidMount() {
    this.props.resetClaim();
  }

  render() {
    const { claimConfig, newClaim } = this.props;
    return (
      <div className="padded-container new-claim-page-container">
        <Helmet>
          <meta charSet="utf-8" />
          <title>AGE | New Claim</title>
        </Helmet>
        {claimConfig.loading ? (
          <LoadingPage />
        ) : (
          <NewClaimForm config={claimConfig.claims} newClaim={newClaim} />
        )}
      </div>
    );
  }
}

const preMapStateToProps = (state: any) => {
  const {
    firebase: { profile },
  }: { firebase: FirebaseReducer.Reducer } = state;
  return {
    profile: profile,
  };
};

const mapQueryToProps = ({ profile }: { profile: any }): ReduxFirestoreQueries => {
  if (!profile.isLoaded || profile.isEmpty) {
    return [];
  }
  return [
    {
      collection: 'config',
      doc: 'claims',
      storeAs: 'claimsConfig',
    },
    {
      collection: 'partners',
      doc: profile.partnerId,
      storeAs: 'partner',
    },
  ];
};

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
    newClaim,
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
    newClaim: INewClaimReducer;
  } = state;
  const claimsConfig = firestore.data.claimsConfig;
  const partner = firestore.data.partner;
  const loading = !isLoaded(claimsConfig) || !isLoaded(partner);
  let claims = null;
  if (!loading) {
    const masterClaim = claimsConfig.claims;
    const partnerConfig = partner.claimTemplate.claims;
    claims = ensureGlassPositionOptions(
      ensureOriginMemberField(_.assign({}, masterClaim, partnerConfig)),
    );
  }
  return {
    claimConfig: {
      claims: claims,
      loading: loading,
    },
    newClaim,
    auth: auth as FirebaseReducer.AuthState,
  };
};

export default compose(
  connect(preMapStateToProps),
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps, { resetClaim }),
)(NewClaimPage);
